import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AppService } from '../shared/services/app.service';
import { StorageService } from '../shared/services/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private appService: AppService,
        private storage: StorageService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            if(currentUser['isPasswordExpired'] || currentUser['pwd_reset_first_time_login']){
                this.router.navigate(['/changepass']);
            }else{
                if(this.appService._currentSessionData.deviceAuthenticated != undefined && !this.appService._currentSessionData.deviceAuthenticated) { 
                    this.router.navigate(['/device_auth']);
                }
                if(!this.appService.checkNativeApp() && this.appService._currentSessionData.qrLoginPassed != undefined && this.appService._currentSessionData.qrLoginPassed != "" && this.appService._currentSessionData.qrLoginPassed != "true") { 
                    this.router.navigate(['/account-management/qr_login']);
                }
            }

            return true;
        }
        this.authenticationService.logout(()=>{
            // not logged in so redirect to login page with the return url
            this.redirectToLogin(state);
            //removing return url because return url could contain a route which the next user may not have
            //permission and this will result in 404 error.
            // this.router.navigate(['/login']);
            
        });
        return false;
    }

    redirectToLogin(state){
        let redirectLink = "/login";
        if(this.appService && this.appService.readCookie("is_kiosk")){
            redirectLink = "/loginwithkiosk"
        }
        if(this.appService && this.appService.readCookie("is_otpkiosk")){
            redirectLink = "/loginwithotpkiosk"
        }
        this.router.navigate([redirectLink],{ queryParams: { returnUrl: state.url }}).then(() => {
            // this.appService._iskiosk = false;
        });
    }
}